import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AddErrorAlert, AddInfoAlert, AddSuccessAlert } from './alert.actions';
import { ZeroAlert } from './alert.model';

@Injectable({ providedIn: 'root' })
export class AlertStateFacade {
  constructor(private _store: Store) {}

  public addInfoAlert(alert: ZeroAlert): Observable<void> {
    return this._store.dispatch(new AddInfoAlert({ alert }));
  }

  public addSuccessAlert(alert: ZeroAlert): Observable<void> {
    return this._store.dispatch(new AddSuccessAlert({ alert }));
  }

  public addErrorAlert(alert: ZeroAlert): Observable<void> {
    return this._store.dispatch(new AddErrorAlert({ alert }));
  }
}
